<script lang="ts">
  import { writable } from "svelte/store"
  import { GivenAnswer } from "../../models/GivenAnswer"

  export let givenAnswer: GivenAnswer

  let errorMessage: String | undefined
  let showUpload = givenAnswer.file ? false : true

  function onFileUpload(event): void {
    let input = event.target as HTMLInputElement

    const reader = new FileReader()
    reader.readAsDataURL(input.files[0])
    reader.onload = function () {
      errorMessage = null
      givenAnswer.file = reader.result as string
    }
    reader.onerror = function (_error) {
      errorMessage = "An error occured with the selected file"
    }
  }

  function toggleUpload() {
    showUpload = !showUpload
  }
</script>

{#if showUpload}
  <div class="grid justify-start gap-2">
    <label>
      <input type="file" id={`answer-${givenAnswer.question.id}`} on:change={onFileUpload} />
      <span class="text-sm text-gray-700 italic">(.jpg, .jpeg, .pdf, .png)</span>
    </label>
    {#if errorMessage}
      <p class="text-red-500 font-bold">{errorMessage}</p>
    {/if}
  </div>
{:else}
  <div>A file has already been uploaded.</div>
  <a on:click|preventDefault={toggleUpload} href={"#"}>Upload a different file</a>
{/if}
